// TODO Export to library
export const PREFIX = 'form';
export { reducer } from 'redux-form';
